import { render, staticRenderFns } from "./SuiteTemplateMain.vue?vue&type=template&id=a7093218&"
import script from "./SuiteTemplateMain.vue?vue&type=script&lang=js&"
export * from "./SuiteTemplateMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports